var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseGrey = function SvgCloseGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#E3E3E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2223 26.7917L23.5554 22.1248L28.2223 17.4579C28.4286 17.2516 28.5445 16.9718 28.5445 16.6801C28.5445 16.3883 28.4286 16.1086 28.2223 15.9023C28.016 15.696 27.7363 15.5801 27.4445 15.5801C27.1528 15.5801 26.873 15.696 26.6667 15.9023L21.9998 20.5692L17.3329 15.9023C17.1266 15.696 16.8468 15.5801 16.5551 15.5801C16.2633 15.5801 15.9836 15.696 15.7773 15.9023C15.571 16.1086 15.4551 16.3883 15.4551 16.6801C15.4551 16.9718 15.571 17.2516 15.7773 17.4579L20.4442 22.1248L15.7773 26.7917C15.571 26.998 15.4551 27.2778 15.4551 27.5695C15.4551 27.8613 15.571 28.141 15.7773 28.3473C15.9836 28.5536 16.2633 28.6695 16.5551 28.6695C16.8468 28.6695 17.1266 28.5536 17.3329 28.3473L21.9998 23.6804L26.6667 28.3473C26.873 28.5536 27.1528 28.6695 27.4445 28.6695C27.7363 28.6695 28.016 28.5536 28.2223 28.3473C28.4286 28.141 28.5445 27.8613 28.5445 27.5695C28.5445 27.2778 28.4286 26.998 28.2223 26.7917Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.6
  })));
};
export default SvgCloseGrey;